"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactDropzone = require("react-dropzone");

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _useLabel2 = _interopRequireDefault(require("../../hooks/useLabel"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Img = _interopRequireDefault(require("../Image/Img"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DropZone = function DropZone(props) {
  var controlledId = props.id,
      placeholder = props.placeholder,
      value = props.value,
      initialLabel = props.label,
      mimeType = props.mimeType,
      previewFit = props.previewFit,
      contolledMultiple = props.multiple,
      className = props.className,
      onChange = props.onChange;

  var _React$useState = _react.default.useState([]),
      files = _React$useState[0],
      setFiles = _React$useState[1];

  var id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;

  var _useLabel = (0, _useLabel2.default)(initialLabel, _extends({}, props, {
    id: id,
    value: files
  })),
      label = _useLabel.label;

  _react.default.useEffect(function () {
    var srcToFile = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(src) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", fetch(src).then(function (res) {
                  return res.arrayBuffer();
                }).then(function (buf) {
                  return new File([buf], src, {
                    type: mimeType
                  });
                }).then(function (file) {
                  return Object.assign(file, {
                    preview: URL.createObjectURL(file)
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function srcToFile(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    if (value) {
      if (typeof value === 'string') {
        srcToFile(value).then(function (file) {
          return setFiles([].concat(files, [file]));
        });
      } else {
        Promise.all(value.map(function (item) {
          return srcToFile(item);
        })).then(function (controlledFiles) {
          return setFiles([].concat(files, controlledFiles));
        });
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]); // const onDrop = React.useCallback(acceptedFiles => {
  //     const reader = new FileReader();
  //     reader.onabort = () => console.log("file reading was aborted");
  //     reader.onerror = () => console.log("file reading has failed");
  //     reader.onload = () => {
  //         // Do whatever you want with the file contents
  //         const binaryStr = reader.result;
  //         console.log(binaryStr);
  //     };
  //     acceptedFiles.forEach(file => reader.readAsArrayBuffer(file));
  // }, []);


  var _useDropzone = (0, _reactDropzone.useDropzone)({
    // accept: mimeType,
    multiple: contolledMultiple,
    onDrop: function onDrop(acceptedFiles) {
      // console.log(acceptedFiles);
      // inputRef.current.files = acceptedFiles;
      // console.log(inputRef.current.files);
      var newFiles = acceptedFiles.map(function (file) {
        return Object.assign(file, {
          preview: URL.createObjectURL(file)
        });
      });
      var totalFiles = [].concat(files, newFiles);
      setFiles(totalFiles);

      if (acceptedFiles.length > 0) {
        if (typeof onChange === 'function') {
          onChange(totalFiles, inputRef);
        }
      }
    }
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive,
      inputRef = _useDropzone.inputRef;

  var thumbs = files.map(function (file) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: file.name,
      className: "uk-uploader__preview " + (contolledMultiple ? 'cell multiple' : '')
    }, /*#__PURE__*/_react.default.createElement(_Img.default, {
      ratio: "1/1",
      fit: previewFit,
      src: file.preview,
      alt: "preview of " + file.name
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "alert",
      size: "tiny",
      icon: "close",
      label: "Remove",
      className: "uk-uploader__cancel",
      onClick: function onClick() {
        var tmp = [].concat(files);
        var toRemove = tmp.findIndex(function (fileTR) {
          return file.name === fileTR.name;
        });
        tmp.splice(toRemove, 1);
        setFiles(tmp);
      }
    }));
  });
  var list = files.map(function (file) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: file.name,
      className: "uk-uploader__preview " + (contolledMultiple ? 'cell multiple' : '')
    }, /*#__PURE__*/_react.default.createElement("div", null, file.name), /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "alert",
      size: "tiny",
      icon: "close",
      label: "Remove",
      className: "uk-uploader__cancel",
      onClick: function onClick() {
        var tmp = [].concat(files);
        var toRemove = tmp.findIndex(function (fileTR) {
          return file.name === fileTR.name;
        });
        tmp.splice(toRemove, 1);
        setFiles(tmp);
      }
    }));
  });
  var classes = (0, _clsx.default)('uk-uploader', contolledMultiple && 'multiple', isDragActive && 'is-dragging', files.length > 0 && 'filled', className);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: classes
  }, label, /*#__PURE__*/_react.default.createElement("div", getRootProps({
    className: 'uk-uploader__dropzone'
  }), /*#__PURE__*/_react.default.createElement("input", _extends({
    id: id
  }, getInputProps(), {
    multiple: contolledMultiple // onChange={() => onChange(inputRef)}

  })), (!files.length || contolledMultiple) && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "uk-uploader__label"
  }, isDragActive ? /*#__PURE__*/_react.default.createElement("span", null, "Drop here") : /*#__PURE__*/_react.default.createElement("span", null, placeholder))), files.length > 0 && mimeType === 'image/*' ? /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-uploader__preview-zone " + previewFit + " " + (contolledMultiple ? 'grid-margin-x small-up-4' : '')
  }, thumbs) : null, files.length > 0 && mimeType !== 'image/*' ? /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-uploader__preview-zone " + previewFit + " " + (contolledMultiple ? 'grid-margin-x small-up-4' : '')
  }, list) : null);
};

DropZone.propTypes = {
  id: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  placeholder: _propTypes.default.string,
  mimeType: _propTypes.default.string,
  previewFit: _propTypes.default.oneOf(['cover', 'contain']),
  multiple: _propTypes.default.bool
};
DropZone.defaultProps = {
  placeholder: 'Drag and drop some files here, or click to select files',
  mimeType: 'image/*',
  previewFit: 'contain',
  multiple: false
};
var _default = DropZone;
exports.default = _default;